<ez-main-layout [theme]="Themes.WHITELABEL">
  <ez-banner>
    <span ngProjectAs="title">Willkommen</span>
    <span ngProjectAs="subtitle">Ein Fehler ist aufgetreten</span>
  </ez-banner>
  <p>
    Ein Fehler ist aufgetreten, bitte entschuldigen Sie die Unnanehmlichkeiten und versuchen Sie es zu einem späteren
    Zeitpunkt erneut.
  </p>
  <p>
    Falls das Problem weiter besteht, wenden Sie sich gerne an uns. Die Kontaktdaten finden Sie in unserem Anschreiben.
  </p>
</ez-main-layout>
